import React from "react";
import style from "./workListCommon.module.scss";
import { useWorkListTabs } from "./hooks/useWorkListTabs";
import { VerticalTabWorkList } from "../../secondary/VerticalTabWorkList";
import { WorklistScreen } from "./worklistScreen";
import { WORKLIST_CONFIG } from "./worklistConfig";

export function NewAdmission({ facilityNumber }) {
  const { dispatch, defaultVerTab, onSelectVerTab, poaCount, nonpoaCount } = useWorkListTabs(facilityNumber, "newAdmissionValues");

  const tabList = [
    {
      name: `POA ${poaCount}`,
      key: "poa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.newAdmissionsPOA} />,
      bottomName: "Pending Wound Photo",
      bgcolor: style.new_admission_bgcolor,
    },
    {
      name: `Non-POA ${nonpoaCount}`,
      key: "nonPoa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.newAdmissionsNONPOA} />,
      bottomName: "Pending Wound Photo",
      bgcolor: style.new_admission_bgcolor,
    },
  ];

  return <VerticalTabWorkList onSelectInt={onSelectVerTab} defaultIndex={defaultVerTab} tabList={tabList} dispatch={dispatch} />;
}
